import React, {useEffect} from 'react'
import apiClient from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { setCountries, setCurrencies } from './countriesSlice';

export const FetchCountriesAndCurrencies = () => {
  const dispatch = useDispatch();

  // Fetch countries
  const { refetch: fetchCountries } = useQuery(
    "get-countries",
    async () => {
      return await apiClient.get("/api/countries");
    },
    {
      enabled: true,
      onSuccess: (res) => {
        if (res.data && res.data.success && res.data.countries) {
          dispatch(setCountries(res.data.countries));
        }
      },
      onError: (err) => {
        console.error('Error fetching countries:', err);
        // Set fallback countries if API fails
        const fallbackCountries = [
          { id: 1, name: 'United States', currency: 'United States Dollar', currency_code: 'USD', code: 'US', phone_code: '+1', flag: 'https://flagcdn.com/w20/us.png' },
          { id: 2, name: 'Nigeria', currency: 'Nigerian Naira', currency_code: 'NGN', code: 'NG', phone_code: '+234', flag: 'https://flagcdn.com/w20/ng.png' },
          { id: 3, name: 'United Kingdom', currency: 'British Pound', currency_code: 'GBP', code: 'GB', phone_code: '+44', flag: 'https://flagcdn.com/w20/gb.png' },
          { id: 4, name: 'Canada', currency: 'Canadian Dollar', currency_code: 'CAD', code: 'CA', phone_code: '+1', flag: 'https://flagcdn.com/w20/ca.png' },
          { id: 5, name: 'Germany', currency: 'Euro', currency_code: 'EUR', code: 'DE', phone_code: '+49', flag: 'https://flagcdn.com/w20/de.png' },
        ];
        dispatch(setCountries(fallbackCountries));
      },
    }
  );

  // Fetch currencies
  const { refetch: fetchCurrencies } = useQuery(
    "get-currencies",
    async () => {
      return await apiClient.get("/api/currencies");
    },
    {
      enabled: true,
      onSuccess: (res) => {
        if (res.data && res.data.success && res.data.currencies) {
          dispatch(setCurrencies(res.data.currencies));
        }
      },
      onError: (err) => {
        console.error('Error fetching currencies:', err);
        // Set fallback currencies if API fails
        const fallbackCurrencies = [
          { id: 'USD', currency_code: 'USD', currency: 'United States Dollar', symbol: '$', name: 'United States Dollar', flag: 'https://flagcdn.com/w20/us.png' },
          { id: 'NGN', currency_code: 'NGN', currency: 'Nigerian Naira', symbol: '₦', name: 'Nigerian Naira', flag: 'https://flagcdn.com/w20/ng.png' },
          { id: 'GBP', currency_code: 'GBP', currency: 'British Pound', symbol: '£', name: 'British Pound', flag: 'https://flagcdn.com/w20/gb.png' },
          { id: 'CAD', currency_code: 'CAD', currency: 'Canadian Dollar', symbol: 'C$', name: 'Canadian Dollar', flag: 'https://flagcdn.com/w20/ca.png' },
          { id: 'EUR', currency_code: 'EUR', currency: 'Euro', symbol: '€', name: 'Euro', flag: 'https://flagcdn.com/w20/de.png' },
        ];
        dispatch(setCurrencies(fallbackCurrencies));
      },
    }
  );

  // Note: Supported coins are already loaded via Redux coinRates, no need for separate API call

  useEffect(() => {
    fetchCountries();
    fetchCurrencies();
  }, []);

  return null;
}

export default FetchCountriesAndCurrencies
